import classNames from 'classnames';

import { CopyLinkButton } from '@components/copyLinkButton/CopyLinkButton';
import { Image } from '@components/Image/Image';
import { Markdown } from '@components/markdown/Markdown';
import { ZineByline } from '@components/zineByline/ZineByline';
import { ZineDateline } from '@components/zineDateline/ZineDateline';

import { DatoZinePostRecord } from '@interfaces';

import styles from './zine-post-header.module.scss';

type ZinePostHeaderProps = {
	post: DatoZinePostRecord;
	className: string;
};

export const ZinePostHeader = ({ post, className }: ZinePostHeaderProps) => {
	const {
		title,
		subheading,
		headerLayout,
		authors,
		firstPublishedAt,
		updatedAt,
		featuredImage,
	} = post;

	return (
		<header
			className={classNames(
				className,
				styles.header,
				styles[`header--${headerLayout}`],
			)}
		>
			<div className={styles.body}>
				<h1 className={styles.title}>{title}</h1>
				{subheading ? (
					<Markdown className={styles.subheading} text={subheading} />
				) : null}
				<div className={styles.lines}>
					<ZineDateline
						isRelative={false}
						publishedAt={firstPublishedAt}
						updatedAt={updatedAt}
					/>
					<ZineByline authors={authors} />
				</div>
				<CopyLinkButton className={styles['copy-button']} />
			</div>
			{featuredImage ? (
				<Image
					className={styles['featured-image']}
					image={featuredImage}
					sizes={`(min-width: 56.25em) ${
						headerLayout === 'variant_1'
							? 'calc(100vw - 8rem)'
							: 'calc(50vw - 6rem)'
					}, calc(100vw - 2rem)`}
				/>
			) : null}
		</header>
	);
};
